<template>
    <div class="el-col el-col-11">
    <!-- v-model="value" -->
        <el-date-picker
            v-model="yearVal"
            align="right"
            type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期" >
        </el-date-picker>
        <el-button @click="get()">点击</el-button>
    </div>
</template>
<script>
import { Select} from 'element-ui'

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            // value: this.value
            yearVal: ''
        }
    },
    props:{
        yearVal:{
            type:String,
            default:''
        }
    },
    watch:{
        yearVal(val){
            this.$emit('update:value', val)
        }
    },
    methods:{
        get(){
            var self=this;
            alert(self.yearVal)
        }
    }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/components/reports/codeCom/singleData.vue?7be26ad2